module.exports = __webpack_public_path__ + "static/media/polar-bear.b1f26790.png";